import React, { useEffect, useState } from 'react';
import OffersCarousel from '../components/OffersCarousel';
import { getCategories } from '../services/apiservice';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Empty } from 'antd';
import { CATEGORY_IMAGE_BASEURL } from '../constants';
import ContentLoader from 'react-content-loader';
import { useLanguage } from '../context/LanguageContext';
import Header from '../components/Header';
import { useHotel } from '../context/HotelContext';
import { getBanner } from '../helpers/_commonHelper';

const CategoryListing = () => {
    const [loading, setLoading] = useState(false);
    const [categoriesList, setCategoriesList] = useState([]);
    const [searchParams] = useSearchParams();
    const menuid = searchParams.get('menuid');
    const navigate = useNavigate();
    const { t } = useLanguage();
    const { hotelDetails = {} } = useHotel();

    const offersList = getBanner(String(hotelDetails.id));

    useEffect(() => {
        window.scrollTo(0, 0);

        if (menuid) {
            fetchCategories(menuid);
        }
    }, [menuid]);

    const fetchCategories = async (menuid) => {
        setLoading(true);
        try {
            const response = await getCategories(menuid);
            if (response.status === 200) {
                let categoriesData = response.data.data || [];
                categoriesData = categoriesData.filter((item) =>
                    Boolean(item.enabled)
                );
                setCategoriesList(categoriesData);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    const categoryClickHandler = (category) => {
        navigate(
            `/menuitems?categoryid=${category.id}&template_id=${
                category.template_id || 3
            }`
        );
    };
    return (
        <>
            <Header showBack />
            <div className=' flex flex-col w-full min-h-screen relative bg-gray-900 gap-4 px-4 pt-4'>
                <OffersCarousel imgList={offersList} />
                <div className='flex flex-row flex-wrap gap-4 pb-16 justify-between'>
                    {loading ? (
                        <LoadingSkelton />
                    ) : categoriesList.length === 0 ? (
                        <Empty />
                    ) : (
                        categoriesList.map((category) => {
                            return (
                                <div
                                    key={category.id}
                                    className='category-card relative  min-h-80 w-1/2 bg-no-repeat bg-cover bg-center cursor-pointer shadow-sm '
                                    onClick={() =>
                                        categoryClickHandler(category)
                                    }
                                    style={{
                                        backgroundImage: category?.image
                                            ? `url(${CATEGORY_IMAGE_BASEURL}` +
                                              encodeURI(category?.image)
                                                  .replace('(', '%28')
                                                  .replace(')', '%29') +
                                              ')'
                                            : '',
                                    }}
                                >
                                    <div className='categoty-title flex text-xl bg-opacity-90 p-4 w-full absolute bottom-0 text-white text-left font-normal'>
                                        {category.name}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
                <div className='flex flex-col text-center justify-center items-center py-4 fixed bottom-0 left-0 w-full bg-gray-900'>
                    <div
                        className='flex flex-col font-normal text-xs text-gray-300'
                        dangerouslySetInnerHTML={{
                            __html: t['restaurant_disclaimer_msg_one'],
                        }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default CategoryListing;

const LoadingSkelton = (props) => {
    return (
        <div className='flex'>
            <ContentLoader
                viewBox='0 0 500 280'
                height={'100%'}
                width={'100%'}
                {...props}
            >
                <rect x='3' y='3' rx='10' ry='10' width='300' height='180' />
                <rect x='6' y='190' rx='0' ry='0' width='292' height='20' />
                <rect x='4' y='215' rx='0' ry='0' width='239' height='20' />
                <rect x='4' y='242' rx='0' ry='0' width='274' height='20' />
            </ContentLoader>
        </div>
    );
};
